import { render, staticRenderFns } from "./RPSideNav.vue?vue&type=template&id=05fbec36&"
import script from "./RPSideNav.vue?vue&type=script&lang=js&"
export * from "./RPSideNav.vue?vue&type=script&lang=js&"
import style0 from "./RPSideNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports